<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb />
      </div>
    </div>

    <b-card>
      <b-overlay :show="showLoading" rounded="sm">
        <h4 class="font-weight-bold mb-4">會員合併</h4>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="m"
          label="欲取代的 UID"
        >
          <b-form-input v-model="fromOuterCode" :disabled="outerQueryIsDone"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="m"
          label="新的 UID"
        >
          <b-form-input v-model="toOuterCode" :disabled="outerQueryIsDone"></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-center">
          <b-button variant="success" @click="handleQueryIsClicked" :disabled="outerQueryIsDone">
            <template>查詢</template>
          </b-button>
          <b-button variant="success" @click="handleCleanIsClicked" class="ml-3" :disabled="!fromOuterCode && !toOuterCode">
            <template>清除</template>
          </b-button>
        </div>
        <template v-if="outerQueryIsDone">
          <h5 class="font-weight-bold mt-4">欲取代的會員資料(此區 UID 將被更新)</h5>
          <b-table
            striped
            hover
            :items="fromCustomers"
            :fields="customerFields"
          >
            <template #cell(merchant)="data">
              <span class="badge badge-primary text-wrap">{{ data.item.merchant.name }}</span>
            </template>
          </b-table>
          <h5 class="font-weight-bold mt-4">新的會員資料(此區資料將被刪除)</h5>
          <b-table
            striped
            hover
            :items="toCustomers"
            :fields="customerFields"
          >
            <template #cell(merchant)="data">
              <span class="badge badge-primary text-wrap">{{ data.item.merchant.name }}</span>
            </template>
          </b-table>
          <div class="d-flex justify-content-center mt-4">
            <b-button variant="success" @click="handleMergeIsClicked" :disabled="outerCodesAreInvalid">
              <template>確認取代</template>
            </b-button>
          </div>
        </template>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import customerApi from "@/apis/customer";
import sweetAlertPresets from "@/mixins/Dashboard/sweetAlertPresets";
import _ from 'lodash';
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    BreadCrumb,
  },
  mixins: [
    sweetAlertPresets,
  ],
  data() {
    return {
      showLoading: false,
      outerQueryIsDone: false,
      fromOuterCode: '',
      toOuterCode: '',
      fromCustomers: [],
      toCustomers: [],
    };
  },
  computed: {
    customerFields() {
      return [
        {
          key: "outer_code",
          label: "UID",
        },
        {
          key: "user_id",
          label: "綁定會員 ID",
        },
        {
          key: "name",
          label: "姓名",
        },
        {
          key: "mobile_phone",
          label: "手機",
        },
        {
          key: "merchant",
          label: "來源通路",
        },
      ];
    },
    outerCodesAreInvalid() {
      return [
        !this.fromOuterCode,
        !this.toOuterCode,
        this.fromOuterCode === this.toOuterCode,
        this.fromCustomers.length === 0,
        false === this.outerQueryIsDone,
        this.multipleFromUsersAreFound,
      ].some(Boolean);
    },
    multipleFromUsersAreFound() {
      return _.uniqBy(this.fromCustomers, 'user_id').length > 1;
    },
  },
  mounted() {
    //
  },
  methods: {
    async handleQueryIsClicked() {
      try {
        if (!this.fromOuterCode || !this.toOuterCode) {
          this.$swal('錯誤', '請輸入欲取代的 UID 和新的 UID', 'error');
          return;
        }
        if (this.fromOuterCode === this.toOuterCode) {
          this.$swal('錯誤', '輸入UID相同，請重新輸入', 'error');
          return;
        }
        this.showLoading = true;
        await Promise.all([
          (async () => {
            this.fromCustomers = _.get(await customerApi.getCustomersByOuterCode(this.fromOuterCode), 'data.data', []);
          })(),
          (async () => {
            this.toCustomers = _.get(await customerApi.getCustomersByOuterCode(this.toOuterCode), 'data.data', []);
          })(),
        ])

        const errorMessages = []
        if (this.fromCustomers.length === 0) {
          errorMessages.push('欲取代的 UID 資料不存在')
        }
        if (this.toCustomers.length === 0) {
          errorMessages.push('新的 UID 資料不存在')
        }
        if (this.multipleFromUsersAreFound) {
          errorMessages.push('資料異常：透過欲取代的 UID 找到多個綁定會員 ID')
        }
        if (errorMessages.length > 0) {
          this.$swal({
            title: '錯誤',
            html: errorMessages.join('<br/>'),
            type: 'error',
          });
        }

        this.outerQueryIsDone = true;
      } catch (e) {
        console.log(e);
      } finally {
        this.showLoading = false;
      }
    },
    async handleCleanIsClicked() {
      this.fromOuterCode = '';
      this.toOuterCode = '';
      this.fromCustomers = [];
      this.toCustomers = [];
      this.outerQueryIsDone = false;
    },
    async handleMergeIsClicked() {
      if (false === await this.confirmDeletion({ text: '是否確定進行合併？', confirmButtonText: "確定合併", cancelButtonText: "不合併" })) {
        return;
      }

      try {
        this.showLoading = true;
        await customerApi.mergeCustomers(this.fromOuterCode, this.toOuterCode);
        this.$swal('成功', '合併成功', 'success');
      } catch (error) {
        const errorCode = _.get(error, 'response.data.code')
        let errorMessage = '合併失敗'
        if (errorCode === 'FROM_CUSTOMER_IS_NOT_FOUND') {
          errorMessage = '欲取代的 UID 資料不存在'
        }
        if (errorCode === 'MULTIPLE_FROM_USERS_ARE_FOUND') {
          errorMessage = '資料異常：透過欲取代的 UID 找到多個綁定會員 ID'
        }
        this.$swal('錯誤', errorMessage, 'error');
        console.error(error);
      }

      this.showLoading = false;
    },
  },
};
</script>
